import React, { useEffect, useState, useContext } from 'react';
import { consts, icons, logoSvg } from '../services/_consts';
import CvMakerContext from '../services/app-context';
import Helper from '../services/Helper'
import { Modal } from './elemans/_elemans'
import { Navigate } from 'react-router'
import { t, lang } from '../services/_lang';

export const FeedBack = ({ onClose, onAfterFeedBackdone, openAs = "modal" }) => {
    //for login
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');

    const [loading, setLoding] = useState(false);
    const [redirect, setRedirect] = useState(false);

    const context = useContext(CvMakerContext);

    const login = async () => {
        setLoding(true);
        const data = await Helper.callApiAsJson({ url: 'resume/NewFeedBack', type: 'post', data: {fullName: userName,msg: password } })

        setLoding(false);
 
            onClose("ok");

    }


    useEffect(() => {


        return () => {

        }
    }, [])

    if (redirect)
        return <Navigate replace to={redirect} />
    return (
        <Modal onClose={onClose} isLg='true' showHeader={openAs == "modal"} >
            <div className={`row ${context.lang.rtl && 'rtl'}`}>
                <div className={`col`}>
                    <h4 className="aviny mb-3">{context.lang.feeBack}</h4>
                    <div className="mb-4 ">
                        <div className="mb-3">
                            <label htmlFor="username" className="form-label">{context.lang.fullName}</label>
                            <input value={userName} onChange={e => setUserName(e.target.value)}  className="form-control"  placeholder="" />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="pass" className="form-label">{context.lang.msg} *</label>
                            <textarea value={password} onChange={e => setPassword(e.target.value)} className="form-control" placeholder="" rows="7" ></textarea>
                        </div>
                        <div className="mb-3">
                            {loading ? <div className="spinner-border" role="status"></div> :
                                <button onClick={login} className="btn btn-outline-dark btn-block me-1 bg-white2">{context.lang.submit} <i className={icons.paperPlane}></i></button>
                            }
                        </div>


                    </div>
                </div>

            </div>
            
        </Modal>
    );

}
export default FeedBack;